import { getGameDetails } from '../../apiservices/LocalStorageService';
import PlayerGeoPlay from '../playerflow/PlayerGeoPlay';
import PlayerQuizPlay from '../playerflow/PlayerQuizPlay';

const PlayGround: React.FC = () => {
  const { gameType } = getGameDetails();

  return (
    <>
      {gameType === 'geoplay' && <PlayerGeoPlay />}
      {gameType === 'quiz' && <PlayerQuizPlay />}
    </>
  );
};

export default PlayGround;
